import toastr from "toastr";
import _ from "lodash";

export const showToastSuccess = (message: string) => {
  toastr.success(message, "", { timeOut: 2000 });
};

export const showToastError = (message: string) => {
  toastr.error(message, "", { timeOut: 2000 });
};

export const showFailedRequestToastError = (e: { response: unknown }) => {
  showToastError(
    _.get(e, "response.data.message") ??
      _.get(e, "response.statusText") ??
      "Something went wrong..."
  );
};
